import { useEffect, useRef } from "react";

const EMBED_SRC = "https://cdn.credly.com/assets/utilities/embed.js";

/**
 * Renders a live, interactive Credly digital badge using Credly's official
 * embed snippet (a div with data-share-badge-* attributes, hydrated by their
 * embed.js). Safe to render more than one on a page; the script is only
 * injected once, and Credly's own script re-scans the DOM for badge divs
 * each time it loads.
 */
export default function CredlyBadge({ badgeId, width = 150, height = 270 }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const existing = document.querySelector(`script[src="${EMBED_SRC}"]`);
    if (existing) {
      // Credly's script re-initialises any badge divs on the page when it
      // (re)runs, but if it already ran before this badge mounted, nudge it
      // by re-appending a fresh copy so it re-scans the DOM.
      const script = document.createElement("script");
      script.src = EMBED_SRC;
      script.async = true;
      document.body.appendChild(script);
      return () => script.remove();
    }
    const script = document.createElement("script");
    script.src = EMBED_SRC;
    script.async = true;
    document.body.appendChild(script);
    return () => script.remove();
  }, [badgeId]);

  return (
    <div
      ref={containerRef}
      data-iframe-width={width}
      data-iframe-height={height}
      data-share-badge-id={badgeId}
      data-share-badge-host="https://www.credly.com"
    />
  );
}
